import React, { useState, FC } from 'react';
import { Props } from './types';
import { FilterButton } from '../FilterButton';
import { FilterMenu } from '../FilterMenu';
import { noop } from '../../../utils/noop';

export const BaseFilter: FC<Props> = props => {
  const {
    children,
    active,
    disabled,
    isOpen: overrideIsOpen,
    label,
    onToggleOpen = noop,
    selected,
    selectedIcon,
    selectedIconFamily,
    isWrapper,
    dataObjectType,
    dataAction,
    hideFilterMenu = false,
    size,
  } = props;

  let [isOpen, setIsOpen] = useState(false);

  if (isWrapper) {
    return <>{children}</>;
  }

  if (typeof overrideIsOpen !== 'undefined') {
    isOpen = overrideIsOpen;
  }
  const toggleOpen = (isOpen: boolean) => {
    setIsOpen(isOpen);
    onToggleOpen(isOpen);
  };

  return (
    <div className="filter-pill" data-object-type={dataObjectType} data-action={dataAction}>
      <FilterButton
        label={label}
        selected={selected}
        // @ts-ignore Remove once FilterButton is converted to TypeScript
        icon={selectedIcon}
        iconFamily={selectedIconFamily}
        disabled={disabled}
        onClick={() => toggleOpen(true)}
        highlighted={active}
        {...(size ? { size } : {})}
      />
      {isOpen && <FilterMenu className={hideFilterMenu ? 'hide-filter-menu' : ''}>{children}</FilterMenu>}
      {isOpen && <div onClick={() => toggleOpen(false)} className="filter-blocker" />}
    </div>
  );
};
